"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _NavSearch = _interopRequireDefault(require("../NavSearch/NavSearch"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "relative",
    backgroundColor: "white",
    color: "black",
    height: theme.spacing(8)
  }
}));

const AppSearch = ({
  className,
  variant,
  expanded = false,
  placeholder,
  q,
  onChange,
  onToggle,
  onReset
}) => {
  const classes = useStyles();
  return _react.default.createElement(_NavSearch.default, {
    className: className || classes.root,
    variant: variant,
    expanded: expanded,
    placeholder: placeholder,
    q: q,
    onChange: onChange,
    onToggle: onToggle,
    onReset: onReset
  });
};

var _default = AppSearch;
exports.default = _default;
module.exports = exports.default;